import { FormProvider, useForm } from 'react-hook-form';

// hooks
import {
  DialogActions,
  DialogContent,
  Typography,
  styled,
} from '@mui/material';
import { useAPIErrorHandler } from '../../../hooks/useAPIErrorHandler';

// apis
import { deleteConnectorById } from '../../../../api/connectors/connectors.api';

// helpers
import { PubSub } from '../../../../utils/eventUtils';
import CbButton from '../../../Buttons/CbButton';
import useNotifications from '../../../../_lib/notifications/useNotifications';

interface RemoveConnectorModalProps {
  data: {
    connectorId: string;
  };
  close: () => void;
}

export const DeleteConnectorModal = (props: RemoveConnectorModalProps) => {
  const notifications = useNotifications();
  const handleAPIError = useAPIErrorHandler();

  const formMethods = useForm();

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = formMethods;

  const onSubmit = () => {
    return deleteConnectorById(props.data.connectorId)
      .then(() => {
        notifications.success('Successfully requested removal of connector.');

        // TODO: This needs to be removed when Connectors page is refactored
        PubSub.publish('connector-page-refetch', null);

        props.close();
      })
      .catch(
        handleAPIError(
          'Not able to delete connector at this time. Please try again later.'
        )
      );
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent style={{ padding: '2rem 5rem' }}>
          <Content>Are you sure you want to delete this connector?</Content>
        </DialogContent>
        <DialogActions>
          <CbButton onClick={props.close} styleName="cancel">
            Cancel
          </CbButton>
          <CbButton
            type="submit"
            loading={isSubmitting}
            disabled={isSubmitting}
            styleName="ctaButton"
          >
            Delete
          </CbButton>
        </DialogActions>
      </form>
    </FormProvider>
  );
};

const Content = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
}));

export const DeleteConnectorModalConfig = {
  DeleteConnectorModal: {
    component: DeleteConnectorModal,
    config: {
      title: 'Delete Connector',
      maxWidth: 'sm',
      fullWidth: true,
    },
  },
};
